import { render, staticRenderFns } from "./PainelErrosDotacoes.vue?vue&type=template&id=ff03e0f0"
import script from "./PainelErrosDotacoes.vue?vue&type=script&lang=js"
export * from "./PainelErrosDotacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports